<template>
  <v-card class="elevation-0">
    <v-card-title class=" purple accent-4">
      <div class="subtitle-1 white--text">{{ typeInfo.name }}</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <label>Name</label>
      <v-text-field
        v-model.trim="name"
        :error-messages="nameErrors"
        type="text"
        outlined
        dense
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn @click.prevent="createBasicData" class="form-btn">
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";

export default {
  mixins: [ValidationMixin],
  props: {
    typeInfo: {
      type: Object,
    },
  },
  data: () => ({
    name: "",
  }),
  validations: {
    name: {
      required,
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    nameErrors() {
      return this.handleFieldErrors(this.$v.name);
    },
  },
  methods: {
    createBasicData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //TYPE IS GET FROM PARENT COMPONENT
        let data = {
          name: this.name,
          type: this.typeInfo.type,
        };

        this.$store.dispatch("InitialData/create", data);

        this.name = null;
        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
